export const CERTIFICATE_VERIFY_PATH = "/verify/learning-certificate";
export function certificateShareUrl(code: string, origin: string): string { return `${origin}${CERTIFICATE_VERIFY_PATH}#${encodeURIComponent(code)}`; }
export function isCertificateVerifyCode(code: string): boolean { return /^[A-Za-z0-9_-]{43}$/.test(code); }
